import { Box } from '@mui/material'
import { images } from '../../utils' 
import useStyles from './style'

const Header = () => {
  const classes = useStyles()

    return (
        <Box className={classes.headContainer}>
          <div className={classes.head}>
            <img
              src={images.logoSanDiego}
              className={classes.logo}
              alt="logo"
            />
          </div>
        </Box>
    ) 
} 

export default Header